export const validation  = {
  blockTitleMaxChar: 60,
  blockParagraphMaxChar: 1000,
  featureParts: {
    min: 1,
    max: 3
  }
}
